import { Stack, Table, Text } from "@mantine/core";
import { useAppSelector } from "../app/hooks";
import { selectArticleDetailsView } from "./articleDetailsSelectors";

export function ArticleDetailsFields() {
  const { groups } = useAppSelector(selectArticleDetailsView);
  return <Stack gap="lg">
    {!groups.length && <Text c="dimmed">Ingen felt matcher søket.</Text>}
    {groups.map(group => <section key={group.name}>
      <Text fw={700} mb="xs">{group.name}</Text>
      <Table striped withTableBorder style={{ tableLayout: "fixed" }}>
        <Table.Thead><Table.Tr><Table.Th w="38%">Felt</Table.Th><Table.Th>Verdi</Table.Th></Table.Tr></Table.Thead>
        <Table.Tbody>{group.rows.map(row => <Table.Tr key={row.id}>
          <Table.Td title={row.id} style={{ overflowWrap: "anywhere" }}>{row.label}</Table.Td>
          <Table.Td style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{row.value}{row.unit && ` ${row.unit}`}</Table.Td>
        </Table.Tr>)}</Table.Tbody>
      </Table>
    </section>)}
  </Stack>;
}
